import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} ActivateExistingStudentsData
 * @property {number} inactive_students
 * @property {number} available_licenses
 * @property {number} can_activate
 * @property {string} reason
 */

/**
 * Custom hook to fetch activate existing students data
 */
export const useActivateExistingStudents = () => {
    const [data, setData] = useState(
    /** @type {ActivateExistingStudentsData | null} */(null)
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const { axiosInstance } = useAxios();

    /**
     * Fetch activate existing students info
     * @returns {Promise<void>}
     */
    const getActivateExistingStudents = async () => {
        try {
            setLoading(true);
            setError("");

            const url = `${TENANT_DOMAIN}/billing/subscription-cycles/activate-existing-students`;
            const response = await axiosInstance.get(url);

            setData(response.data?.data || null);
        } catch (err) {
            setData(null);

            if (err?.response?.status === 500) {
                setError(ERROR_MESSAGES.INTERNAL_SERVER);
            } else {
                setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
            }
        } finally {
            setLoading(false);
        }
    };

    return {
        data,
        loading,
        error,
        getActivateExistingStudents,
    };
};